import { useTranslations } from 'next-intl';

import type { SlotLocationBlockTranslations } from '@ui/components/features/locationLibrary';

/** Strings for the prop-driven `SlotLocationBlock` used at slot creation / edit. */
export function useSlotLocationPickerTranslations(): SlotLocationBlockTranslations {
  const t = useTranslations('Locations');
  return {
    addressRowLabel: t('slotInPersonRow'),
    onlineRowLabel: t('slotOnlineRow'),
    addressEmpty: t('slotAddressEmpty'),
    onlineRoomTitle: t('slotOnlineDefaultTitle'),
    onlineRoomHint: t('slotOnlineDefaultHint'),
    onlineManualHint: t('slotOnlineManualHint'),
    manage: t('slotManageLocations'),
    kindVenue: t('kindVenue'),
    kindAtHome: t('kindAtHome'),
    notInPerson: t('slotNotInPerson'),
    noOnline: t('slotNoOnline')
  };
}
